const base = 'map/';
export const CLEAR_SELECTION = `${base}clearSelection`;
export const HOVER_FEATURE = `${base}hoverFeature`;
export const MAP_LOADED = `${base}loaded`;
export const SELECT_FEATURE = `${base}selectFeature`;
export const UNHOVER_FEATURE = `${base}unhoverFeature`;
